import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';

/**
 * Client for portal CAP mapping admin APIs.
 * All endpoints are super_admin gated server-side; response bodies are raw DTOs.
 */
const BASE = `${PORTAL_API_BASE_URL}/api/admin/cap-mappings`;

const req = (opts) => request({ ...opts, throw400Error: true });

export const fetchCapClients = () => req({ method: 'GET', url: `${BASE}/clients` });

export const fetchCapMappings = (clientName) =>
  req({
    method: 'GET',
    url: `${BASE}?clientName=${encodeURIComponent(clientName)}`,
  });

export const searchCapLocations = (q) =>
  req({
    method: 'GET',
    url: `${BASE}/locations?q=${encodeURIComponent(q)}`,
  });

export const createCapMapping = (body) =>
  req({
    body: JSON.stringify(body),
    method: 'POST',
    url: BASE,
  });

export const updateCapMapping = (id, body) =>
  req({
    body: JSON.stringify(body),
    method: 'PUT',
    url: `${BASE}/${encodeURIComponent(id)}`,
  });

export const deleteCapMapping = (id) =>
  req({
    method: 'DELETE',
    url: `${BASE}/${encodeURIComponent(id)}`,
  });
